
// Past this many pixels of scroll the pill is shown. Matches the landing's original value;
// the static header above it is ~68-76px tall, so this is "the header has just left".
export const THRESHOLD = 80;

export function initFloatingHeader() {
  const pill = document.getElementById("floating-header");
  if (!pill) return;

  let visible = null;

  const update = () => {
    const next = window.scrollY > THRESHOLD;
    if (next === visible) return;
    visible = next;

    if (next) {
      pill.style.opacity = "1";
      pill.style.transform = "translateY(0) scale(1)";
      pill.style.pointerEvents = "auto";
    } else {
      pill.style.opacity = "0";
      pill.style.transform = "translateY(-20px) scale(0.92)";
      pill.style.pointerEvents = "none";
    }
  };

  window.addEventListener("scroll", update, { passive: true });
  update();
}
